/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
    TransactionTypeToJSONTyped,
} from './TransactionType';
import type { TransactionSubject } from './TransactionSubject';
import {
    TransactionSubjectFromJSON,
    TransactionSubjectFromJSONTyped,
    TransactionSubjectToJSON,
    TransactionSubjectToJSONTyped,
} from './TransactionSubject';

/**
 * Represents a single transaction of Fuel.
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    updatedAt: number;
    /**
     * 
     * @type {TransactionSubject}
     * @memberof Transaction
     */
    subject: TransactionSubject;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    user: string;
    /**
     * 
     * @type {TransactionType}
     * @memberof Transaction
     */
    type: TransactionType;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    amount: number;
    /**
     * 
     * @type {object}
     * @memberof Transaction
     */
    reference?: object;
    /**
     * Running balance after this transaction
     * @type {number}
     * @memberof Transaction
     */
    runningBalance?: number;
}



/**
 * Check if a given object implements the Transaction interface.
 */
export function instanceOfTransaction(value: object): value is Transaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function TransactionFromJSON(json: any): Transaction {
    return TransactionFromJSONTyped(json, false);
}

export function TransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'subject': TransactionSubjectFromJSON(json['subject']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
        'user': json['user'],
        'type': TransactionTypeFromJSON(json['type']),
        'amount': json['amount'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'runningBalance': json['runningBalance'] == null ? undefined : json['runningBalance'],
    };
}

export function TransactionToJSON(json: any): Transaction {
    return TransactionToJSONTyped(json, false);
}

export function TransactionToJSONTyped(value?: Transaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'subject': TransactionSubjectToJSON(value['subject']),
        'notes': value['notes'],
        'adminNotes': value['adminNotes'],
        'user': value['user'],
        'type': TransactionTypeToJSON(value['type']),
        'amount': value['amount'],
        'reference': value['reference'],
        'runningBalance': value['runningBalance'],
    };
}

